//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductPrice from '~/components/product/ProductPrice.vue'
import {AppMixin} from '~/node_modules/sitis-nuxt/lib/mixins/index'
import {namespace} from 'nuxt-property-decorator';
import {
    namespace as cartStore,
    actionType as cardActionType
} from '~/node_modules/sitis-nuxt/lib/store/modules/cart-store';

const CardStore = namespace(cartStore);

export default {
    name: 'AddToCart',

    props: {
        price: {
            type: Number
        },
        oldPrice: {
            type: Number
        },
        productId: {
            type: Number
        },
        bonusValue: {
            type: Number
        },
        quantity: {
            type: Number,
            default: 0
        },
        isInWishlist: {
            type: Boolean,
            default: false
        },
        isShowButtonMyAcuvue: {
            type: Boolean,
            default: false
        },
        addressStore: {
            type: Array,
            default() {
                return []
            }
        },
        isAddedToCartInit: {
            type: Boolean,
            default: false
        },

        // Есть ли у товара модификация
        isProductModification: {
            type: Boolean,
            default: false
        },
        // Товары (с выбранными опциями) в наличии
        productAvailability: {
            type: Object,
            default: () => {
                return {}
            }
        },
        productAvailabilityAddress: {
            type: Object,
            default: () => {
                return {}
            }
        },

        product: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },

    mixins: [AppMixin],

    components: {
        ProductPrice
    },

    computed: {
        setAddress() {
            const activeCityName = this.appCfg?.city?.model?.name || 'Екатеринбург'
            const addresses = this.addressStore.filter(t => t.cityName === activeCityName);

            if (addresses.length > 0) {
                return addresses
            }

            const cities = []
            this.addressStore.map((address) => {
                if (!cities.find(t => t.address === `г. ${address.cityName}`)) {
                    const stores = this.addressStore.filter(
                        t => t.cityName === address.cityName
                    )

                    cities.push({
                        id: address.id,
                        address: `г. ${address.cityName}`,
                        stores: [...stores],
                        lat: address.lat,
                        lon: address.lon
                    })
                }
            })

            return cities
        },

        isAllAvaiblesModification() {
            let allAvaiblesModification = true

            Object.keys(this.productAvailability).map((key) => {
                if (!this.productAvailability[key]) {
                    allAvaiblesModification = false
                }
            })

            return allAvaiblesModification
        },

        isAddedToCart: function () {
            if (this.isProductModification) {
                return this.isAddedToCartInit;
            }

            const cartItems = this.$store.state?.cart?.items || [];
            const isAdded = Boolean(cartItems.find((t) => t?.product?.id === this.productId));

            return isAdded
        },
        countAddedToCart: function () {
            const cartItems = this.$store.state?.cart?.items || [];
            const product = cartItems.find((t) => t?.product?.id === this.productId) || {};

            return product?.quantity || 0
        }
    },
    methods: {
        getDeliveryDays: function () {
            return this.product?.brand?.name === 'ACUVUE' ? this.vars['Срок доставки (ACUVUE)'] : this.vars['Срок доставки']
        },
        getLabelProductAcuvueFitted0() {
            if (!this.isShowButtonMyAcuvue) {
                return ''
            }

            const myAcuvue = this.$store.state?.myacuvue?.profile || {}

            if (Object.keys(myAcuvue).length <= 0) {
                return 'Получить скидку на эти линзы в MyACUVUE®'
            }
        },
        getLabelProductAcuvueFitted1() {
            if (!this.isShowButtonMyAcuvue) {
                return ''
            }

            const myAcuvue = this.$store.state?.myacuvue?.profile || {}
            const fittedProducts = myAcuvue?.fitted_products || {}
            const isProfileVouchers = myAcuvue?.discount_vouchers || []

            if (isProfileVouchers.length > 0 && fittedProducts[this.productId]) {
                return 'Вам доступна скидка 300/500 рублей'
            }
        },
        getLabelProductAcuvueFitted2() {
            if (!this.isShowButtonMyAcuvue) {
                return ''
            }

            const myAcuvue = this.$store.state?.myacuvue?.profile || {}
            const fittedProducts = myAcuvue?.fitted_products || {}

            if (
                fittedProducts[this.productId] &&
                fittedProducts[this.productId]?.bonuses > 0
            ) {
                return `За покупку вам будут начислено ${
                    fittedProducts?.[this.productId]?.bonuses
                } баллов MyAcuvue`
            }
        },

        openStore(store) {
            this.$emit('openStore', store)
        },


        changeQuantityProduct: async function (type) {
            const cartItems = this.$store.state?.cart?.items || [];
            const product = cartItems.find((t) => t?.product?.id === this.productId) || {};

            const url = `cart/${product.id}`;

            const newQuantity = Boolean(type === "+") ? product.quantity + 1 : product.quantity - 1;

            if (newQuantity === 0) {
                await this.deleteProductFromCard(url);

                return
            }

            const response = await this.$api.agent.transport.put(url, {
                quantity: newQuantity
            }).then((res) => {
                return res.data
            }).catch((err) => {
                return {error: err.response}
            });

            if (response.error) {
                this.$customNotification.error("Ошибка изменения количества товара в корзине. Попробуйте позже.")

                return
            }

            this.updateCartItems();
        },
        deleteProductFromCard: async function (url) {

            const response = await this.$api.agent.transport.delete(url).then((res) => {
                return res.data
            }).catch((err) => {
                return {error: err.response}
            });

            if (response.error) {
                this.$customNotification.error("Ошибка удаления товара из корзины. Попробуйте позже.")

                return
            }

            this.$yandexCommerce("remove", [{
              ...this.product,
              quantity: 1
            }]);

            this.updateCartItems();
        },
        updateCartItems: async function () {
            this.$store.dispatch(`cart/${cardActionType.GET_CART}`);
        },


        getAddressesList: function (list) {
            const activeCityName = this.appCfg?.city?.model?.name || 'Екатеринбург'
            const addresses = list.filter(t => t.city_name === activeCityName);

            if (addresses.length > 0) {
                return addresses
            }

            const cities = []
            list.map((address) => {
                if (!cities.find(t => t.address === `г. ${address.city_name}`)) {
                    const stores = list.filter(
                        t => t.city_name === address.city_name
                    )

                    cities.push({
                        id: address.id,
                        address: `г. ${address.city_name}`,
                        stores: [...stores],
                        lat: address.lat,
                        lon: address.lon
                    })
                }
            })

            return cities
        }
    }
}
